import React from 'react';

function Navigation({ activeSection, onSectionChange }) {
  return (
    <nav style={{
      display: 'flex',
      justifyContent: 'center',
      margin: '0 0 20px',
      borderBottom: '1px solid #eee',
      paddingBottom: '10px',
    }}>
      <button
        onClick={() => onSectionChange('comparison')}
        style={{
          backgroundColor: activeSection === 'comparison' ? '#3498db' : 'transparent',
          color: activeSection === 'comparison' ? 'white' : '#333',
          border: 'none',
          borderRadius: '5px',
          padding: '8px 16px',
          margin: '0 5px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: activeSection === 'comparison' ? 'bold' : 'normal',
        }}
      >
        Comparaison de joueurs
      </button>
      
      <button
        onClick={() => onSectionChange('upcomingMatches')}
        style={{
          backgroundColor: activeSection === 'upcomingMatches' ? '#3498db' : 'transparent',
          color: activeSection === 'upcomingMatches' ? 'white' : '#333',
          border: 'none',
          borderRadius: '5px',
          padding: '8px 16px',
          margin: '0 5px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: activeSection === 'upcomingMatches' ? 'bold' : 'normal',
        }}
      >
        Matchs à venir
      </button>
    </nav>
  );
}

export default Navigation;